import React from 'react';
import {CommonCreate} from '../Common';
import {getInputs} from './Common';

export const MaterialSubFamilyCreate = props => (
  <CommonCreate
    {...{
      ...props,
      fields: getInputs(),
    }}
  />
);
